// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfg_a"};